function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
export const ArrowDownFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 17C11.483 16.9974 10.9946 16.7624 10.67 16.36L6.45997 11.26L6.45997 11.26C5.95805 10.6336 5.85713 9.77581 6.19997 9.05C6.4783 8.41856 7.09995 8.00803 7.78997 8H16.21V8C16.9 8.00803 17.5216 8.41856 17.8 9.05V9.05C18.1428 9.77581 18.0419 10.6336 17.54 11.26L13.33 16.36C13.0053 16.7624 12.517 16.9974 12 17Z",
  fill: "currentColor"
}));